import React from 'react'

import ProductItemSkeleton from '../ProductItem/ProductItemSkeleton/ProductItemSkeleton'
import styles from '../styles.module.scss'
import { useSelector } from 'react-redux'
import cn from 'classnames'

const SKELETON_COUNT = 7

const ProductsSkeleton = () => {
  const referralData = useSelector(({ billing }) => billing.referralData)

  return (
    <div className={cn(styles.grid, [referralData && styles.oneColumn])}>
      {Array.from({ length: SKELETON_COUNT }).map((_, index) => (
        <ProductItemSkeleton key={index} />
      ))}
    </div>
  )
}

export default ProductsSkeleton
